import styled from "styled-components"

export const TerminalAddButtonContainer = styled.div`
  position: absolute;
  bottom: -5.4rem;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  pointer-events: none;
`

/** Solid filled style — terminal "+" is the primary action for appending a
 *  new child / parallel sibling to this node's output. Visually distinct
 *  from the subtle outlined mid-edge insert button. */
export const TerminalAddButtonCircle = styled.button<{ $highlighted?: boolean }>`
  pointer-events: all;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
  border: 0.1rem solid ${(p) => p.theme.colors.turquoiseDark};
  background: ${(p) =>
    p.$highlighted ? p.theme.colors.turquoiseDarker : p.theme.colors.turquoiseDark};
  color: ${(p) => p.theme.colors.white};
  font-size: 1.7rem;
  ${(p) => p.theme.bold};
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: ${(p) =>
    p.$highlighted
      ? "0 0 0 0.4rem rgba(57, 179, 155, 0.25), 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15)"
      : "0 0.15rem 0.4rem rgba(57, 179, 155, 0.35)"};
  transform: ${(p) => (p.$highlighted ? "scale(1.25)" : "scale(1)")};
  transition: all 0.15s ease;
  padding: 0;

  &:hover {
    background: ${(p) => p.theme.colors.turquoiseDarker};
    border-color: ${(p) => p.theme.colors.turquoiseDarker};
    box-shadow: 0 0.2rem 0.6rem rgba(57, 179, 155, 0.45);
    transform: scale(1.08);
  }
`
